import { useMutation, useQuery } from '@tanstack/react-query';

import { preferencesOptions, useUpdateWelcomeGuide } from '@/entities/practice-member';

const FIRST_DICTATION = 'dictate-recap';

export function useMarkFirstDictation() {
    const { data } = useQuery(preferencesOptions());
    const { mutateAsync } = useMutation(useUpdateWelcomeGuide());

    // An arrow, not a function declaration: React Compiler mis-memoizes the hoisted declaration
    // and the returned value is not callable at runtime.
    return async () => {
        const completedTasks = data?.['welcome-guide']?.completedTasks;

        if (!completedTasks || completedTasks.includes(FIRST_DICTATION)) {
            return;
        }

        try {
            await mutateAsync({ completedTasks: [...completedTasks, FIRST_DICTATION] });
        } catch {
            // Generation is already accepted by the time this runs, so a failed mark must not
            // surface as a generation failure. onError rolls the optimistic cache back, leaving
            // the cues visible — correct, since the server never recorded the completion.
        }
    };
}
